import React from "react";
import "./Cosection.css";
import sampleImage from '../Images/Assistance.webp';
import { Link } from "react-router-dom";

const Cosection = () => {
  return (
    <div className="cosection-container">
      {/* Image Card */}
      <div className="cosection-image-card">
        <img src={sampleImage} alt="Support" className="cosection-image" />
      </div>

      {/* Text Content */}
      <div className="cosection-text">
        <h2 className="cosection-heading">Need Assistance?</h2>
        <p className="cosection-subtext">
          Our team is here to answer your questions and guide you every step of
          the way. Reach out and let’s make things easier for you.
        </p>
        <Link to="/contact">
          <button className="cosection-btn">Get in Touch</button>
        </Link>
      </div>
    </div>
  );
};

export default Cosection;
